import React, { useEffect } from 'react';
import NecklaceVisualization from './NecklaceVisualization';
import ScaleNotation from './ScaleNotation';

export const NecklaceModal = ({ 
  scale, 
  mode, 
  superscaleIndex, 
  scaleNumber,
  onClose,
  onPlayScale,
  onPurchase 
}) => {
  // Close on ESC key and handle URL cleanup
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        handleClose();
      }
    };
    
    document.addEventListener('keydown', handleEscape);
    // Prevent body scroll when modal is open
    document.body.style.overflow = 'hidden';
    
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  const handleClose = () => {
    // Clear the hash from URL
    if (window.location.hash) {
      window.history.pushState('', document.title, window.location.pathname + window.location.search);
    }
    onClose();
  };

  return (
    <div className="necklace-modal-overlay" onClick={handleClose}>
      <div className="necklace-modal" onClick={(e) => e.stopPropagation()}>
        <button className="necklace-modal__close" onClick={handleClose} aria-label="Close">
          ×
        </button>
        
        <div className="necklace-modal__header">
          <h3>Scale #{scaleNumber}</h3>
          <p className="necklace-modal__subtitle">
            Superscale {superscaleIndex} • Mode {mode}
          </p>
        </div>
        
        <div className="necklace-modal__scale-notation">
          <ScaleNotation scale={scale} onNoteClick={() => {}} />
        </div>
        
        <div className="necklace-modal__content">
          <NecklaceVisualization 
            scale={scale} 
            mode={mode} 
            superscaleIndex={superscaleIndex}
          />
        </div>
        
        <div className="necklace-modal__actions" data-screenshot-hide>
          <button className="necklace-action-btn necklace-action-btn--play" onClick={onPlayScale}>
            <span>▶</span> Play Scale
          </button>
          <button className="necklace-action-btn necklace-action-btn--purchase" onClick={onPurchase}>
            <span>$</span> Purchase NFT
          </button>
        </div>
      </div>
    </div>
  );
};
